import React from 'react'
import styled from 'styled-components'

type Props = {
  cols?: number[]
  noMarginBottom?: boolean
}
export const FormGroup: React.FC<Props> = ({ noMarginBottom, children }) => {
  return (
    <StyledFormGroup noMarginBottom={noMarginBottom}>
      {children}
    </StyledFormGroup>
  )
}

interface FormGroupProps {
  noMarginBottom?: boolean
}

const StyledFormGroup = styled.div<FormGroupProps>`
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0' : '2rem')};
`
